const translations = {
  please_wait: 'Please wait...',
  error: 'An error has occurred. Try again later.',
  export_generated: 'Export generated successfully',
  validation_errors: 'There are validation errors. Please check all fields before saving.',
  please_make_sure_not_duplicated: "Please make sure all required fields are filled and it's not a duplicated vehicle.",
  go_to_home: 'Go to home page',
  processing_progress: 'Processing {{current}}/{{total}}',
  process_completed: 'Process completed',
  process_completed_with_errors: 'Completed with errors ({{failed}} failed)',
  process_failed: 'Process failed',
  process_canceled: 'Process canceled',
};

export default translations;
